var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWim2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M557-518 387-688l57-56 113 113 227-226 56 56-283 283ZM320-220l278 76 167-51-45-45H598q-20 0-39-1.5t-37-8.5l-93-31 22-78 81 27q16 5 32.5 8.5T598-320h42l-39-39-217-81h-64v220ZM80-80v-440h304q7 0 14 1.5t13 3.5l53 19 365 364-229 72-280-78v58H80Zm80-80h80v-280h-80v280Zm718 78-56 56L26-822l56-56L878-82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWim2);
export default __webpack_public_path__ + "static/media/wim2.811575a904832936d214f5146c706423.svg";
export { ForwardRef as ReactComponent };